import { EquipmentDict } from "../../../../model/Dto/Dict/Equipment";
import { ApiRequest, RequestMethod } from "../../../request";

const URL = "/api/equipment";

export async function getAllEquipmentDict(categoryId?: string): Promise<EquipmentDict[]> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.GET);
    const params = new URLSearchParams();
    if (categoryId) params.append("categoryId", categoryId);
    const query = params.toString();
    apiRequest.setUrl(query ? `${URL}?${query}` : URL);
    const response: any = await apiRequest.send();
    return response.data;
}
